
import React from 'react';
import RecipeComponent from '../ui/colorComponent/RecipeComponent.tsx'

const RecipeList = () => {
    return (
        <main>
            <RecipeComponent />
        </main>
    )
};

export default RecipeList;